import api from "./api";

// Resultado do "sincronizar agora" (SiscomexSyncItemViewModel)
export interface DuimpSyncResult {
  processId: string;
  duimp: string;
  situation?: string;
  channel?: string;
  changes: string[];
  error?: string;
}

export const syncProcessDuimp = async (processId: string): Promise<DuimpSyncResult> =>
  (await api.post(`/api/siscomex/process/${processId}/sync`)).data;

/** Extrato em PDF montado no backend com os dados já gravados da DUIMP. */
export const downloadDuimpStatement = async (processId: string) => {
  const response = await api.get(`/api/siscomex/process/${processId}/statement`, { responseType: "blob" });
  const disposition = response.headers["content-disposition"] ?? "";
  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  const plain = disposition.match(/filename="?([^";]+)"?/i)?.[1];
  const fileName = encoded ? decodeURIComponent(encoded) : plain ?? "Extrato DUIMP.pdf";
  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};

// Resultado do "sincronizar carga" (CargoSyncItemViewModel)
export interface CargoSyncResult {
  processId: string;
  source?: string;
  reference?: string;
  situation?: string;
  changes: string[];
  error?: string;
}

export const syncProcessCargo = async (processId: string): Promise<CargoSyncResult> =>
  (await api.post(`/api/siscomex/process/${processId}/sync-cargo`)).data;
